export default {"src":"/_next/static/media/arr_backbold.8eedcbe2.svg","height":20,"width":13,"blurWidth":0,"blurHeight":0};